import * as React from 'react'

export function useWindowResize(): [number, number] {
  const [dimensions, setDimensions] = React.useState<[number, number]>([0, 0])
  React.useEffect(() => {
    const handler = () => {
      const prev = dimensions
      const next: [number, number] = [window.innerWidth, window.innerHeight]
      if (prev[0] !== next[0] || prev[1] !== next[1]) {
        setDimensions(next)
      }
    }
    window.addEventListener('resize', handler)
    return () => window.removeEventListener('resize', handler)
  }, [dimensions])
  return dimensions
}
